export default function getImage(file) {
  return `${process.env.REACT_APP_API_HTTP}://${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}/image/${file}`;
}
